export const urlValidator = ({ url, protocols = ["https:", "http:"] }) => {
  try {
    const parsedUrl = new URL(url);
    return protocols.includes(parsedUrl.protocol);
  } catch (error) {
    return false;
  }
};

export const mailValidator = ({ url = "" }) => {
  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}(?:\?.*)?$/gi;
  return !!url.match(regex)?.length;
};
